import { JobList } from "../../assets/data/Constants";
import TkHelpIcon from "../../components/atoms/TkHelpIcon";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const stepper = ["対象施設一覧/対象外施設への異動情報", "機構へ提出"];

const headList: any[] = [
  {
    headTitle: (
      <>
        職員番号
        <TkHelpIcon helpMessage={"復帰する職員の職員番号です。"} />
      </>
    ),
  },
  {
    headTitle: (
      <>
        職員氏名
        <TkHelpIcon helpMessage={"復帰する職員の職員氏名（フリガナ）です。"} />
      </>
    ),
  },
  {
    headTitle: (
      <>
        職員名漢字
        <TkHelpIcon
          helpMessage={
            "復帰する職員の職員氏名（漢字）です。外字や「髙（はしごだか）」、「﨑（たつさき）」等の環境依存文字は、正しく表示されない恐れがあります。"
          }
        />
      </>
    ),
  },
  {
    headTitle: (
      <>
        生年月日
        <TkHelpIcon helpMessage={"復帰する職員の生年月日です。"} />
      </>
    ),
  },
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    lineTitle: "復帰した施設",
    keyword: "title1",
    type: "lineTitle",
  },
  {
    title: "施設番号",
    keyword: "facilityNo",
    type: "text",
    helpicon: true,
    helpText: "復帰先の施設番号です。",
  },
  {
    title: "施設名",
    keyword: "facilityName",
    type: "text",
    helpicon: true,
    helpText: "復帰先の施設等の名称です。",
  },
  {
    title: "種類",
    keyword: "facilityKind",
    type: "text",
    helpicon: true,
    helpText: "復帰先施設等の施設種類・サービス種類です。",
  },
  {
    lineTitle: "異動/復帰年月日",
    keyword: "title2",
    type: "lineTitle",
  },
  {
    title: "共済契約対象外施設等異動年月日",
    keyword: "changeDate",
    type: "text",
    helpicon: true,
    helpText:
      "制度に加入していない施設・事業（契約対象外施設）へ配属された日の前日です。（4/1配属であれば、その前日の3/31となります。）",
  },
  {
    title: "共済契約対象施設等復帰年月日",
    keyword: "returnDate",
    type: "text",
    helpicon: true,
    helpText:
      "制度に加入していない施設・事業（契約対象外施設）から制度に加入している施設・事業（契約対象施設）への復帰日（配属日）です。",
  },
  {
    lineTitle: "復帰時の職種・本俸月額",
    keyword: "title3",
    type: "lineTitle",
  },
  {
    title: "職種",
    keyword: "jobCd",
    type: "selectForm",
    selectPropsList: TkGetCodeList(JobList),
    requiredIcon: true,
    helpicon: true,
    helpText: (
      <>
        被共済職員の職種です。予め指定されてい職種の中から一番近いものを選択してください。詳しくは、
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫職種について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご確認ください。
      </>
    ),
  },
  {
    title: "復帰時の俸給表の額",
    keyword: "salaryTableAmt",
    type: "amount",
    requiredIcon: true,
    useNumberValue: true,
    inputProps: { maxLength: 9 },
    helpicon: true,
    helpText: (
      <>
        共済契約者が給与規程で定める本俸月額を入力してください。ただし、給与規程で本俸が定められていない職員は、雇用契約書で定める労働条件をもとに計算した額となります。詳しくは、
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫俸給表の額について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご確認ください。
        <br />
        【注意点】実際の支給された額を記載するのではなく、給与規程や雇用契約書等に定められた額を記載してください。
      </>
    ),
  },
  {
    title: "復帰時の俸給の調整額",
    keyword: "salaryAdjustmentAmt",
    type: "amount",
    requiredIcon: true,
    useNumberValue: true,
    inputProps: { maxLength: 9 },
    helpicon: true,
    helpText: (
      <>
        「俸給の調整額」対象手当として当機構が認めた手当があれば、その合計金額を入力してください。
        登録されている手当以外の金額は計上することができません。未登録の場合は登録申請が必要です。
        ※俸給の調整額については、
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫俸給の調整額について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご確認ください。
      </>
    ),
  },
];

const schema = {
  jobCd: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  salaryTableAmt: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    min: {
      value: 0,
      message: TkPropertyMessageGet("TKMSG_SCR0047E", "0"),
    },
    max: {
      value: 999999999,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "999999999"),
    },
  },
  salaryAdjustmentAmt: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    min: {
      value: 0,
      message: TkPropertyMessageGet("TKMSG_SCR0047E", "0"),
    },
    max: {
      value: 999999999,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "999999999"),
    },
  },
};

export { fakeTableList, schema, headList, stepper };
